export enum UploadRequirement {
  REQUIRED="REQUIRED",
  OPTIONAL="OPTIONAL",
  NEVER="NEVER"
}
